import { richTextPlainText } from "../shared/rich-text-plain";
import type { Editor } from "./canvas";
import type { TLShape } from "@tldraw/tlschema";
import { draftingLabels } from "../shared/drafting";
import { displayObjectName } from "./object-name";

export function searchBoard(
  editor: Editor,
  shapes: readonly TLShape[],
  query: string,
) {
  const term = query.trim().toLocaleLowerCase();
  if (!term) return [];
  return shapes
    .filter((shape) => !editor.isShapeHidden(shape))
    .map((shape) => {
      const props = shape.props as Record<string, unknown>;
      const asset =
        shape.type === "image" && shape.props.assetId
          ? editor.getAsset(shape.props.assetId)
          : undefined;
      const filename = asset?.type === "image" ? asset.props.name : "";
      const name =
        typeof props.name === "string"
          ? props.name
          : shape.type === "image"
            ? displayObjectName(
                shape.meta.name || shape.props.altText || filename,
              )
            : "";
      const text =
        shape.type === "drafting"
          ? `${draftingLabels[shape.props.kind]} ${shape.props.kind === "leader" ? shape.props.label : ""}`
          : shape.type === "table"
            ? shape.props.rows.map((row) => row.join(" ")).join("\n")
            : "richText" in shape.props
              ? richTextPlainText(shape.props.richText)
              : filename;
      return {
        shape,
        label: String(name || text || shape.type).slice(0, 180),
        text,
      };
    })
    .filter((result) =>
      `${result.label} ${result.text}`.toLocaleLowerCase().includes(term),
    );
}
